import React from 'react';

import './style.scss';

interface propsInterface {
  children: React.ReactNode;
  className?: string;
  border?: boolean;
  type?: 'default' | 'type-1';
}

const Wrapper = ({ children, className, border, type = 'default' }: propsInterface) => {
  let classNames = `v-wrapper v-wrapper__${type}`;
  classNames = className ? `${classNames} ${className}` : classNames;
  classNames = border ? `${classNames} v-wrapper__border` : classNames;

  return (
    <div className={classNames}>
      {children}
    </div>
  );
}

export default Wrapper;
